module.exports = __webpack_public_path__ + "static/media/d20ru.d87a170a.pdf";